module.exports = __webpack_public_path__ + "static/img/html5.1d03fc2a.png";